import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import { isPresent } from 'helpers/string_helpers';

const EmptyState = (props) => {
  const message = typeof(props.message) === 'string' ? <h4>{props.message}</h4> : props.message;
  const image = isPresent(props.imageSrc) ? <img className="mb-4" src={props.imageSrc} style={{ height: 62 }}/> : null;

  const body = (
    <React.Fragment>
      {image}
      {message}
      {props.subMessage &&
        <div className='text-muted'>{props.subMessage}</div>
      }
    </React.Fragment>
  );

  if (props.wrapInPanel) {
    return (
      <Panel className="text-center dashed-border m-0">
        <Panel.Body className="p-5">{body}</Panel.Body>
      </Panel>
    );
  }

  return (
    <div className="text-center p-5">{body}</div>
  );
};

EmptyState.propTypes = {
  imageSrc: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  wrapInPanel: PropTypes.bool
};

export default EmptyState;
